module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wd-box"
  }, [_c('div', {
    ref: "listContainer",
    staticClass: "wd-box-container",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [(_vm.data) ? _c('div', {
    staticClass: "wd-user"
  }, [_c('div', {
    staticClass: "wd-user-left"
  }, [_c('img', {
    staticClass: "wd-user-img",
    attrs: {
      "src": _vm.$store.state.userInfo.headPortrait,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wd-user-content"
  }, [_c('span', {
    staticClass: "wd-user-content-span"
  }, [_vm._v(_vm._s(_vm.$store.state.userInfo.nickName))]), _vm._v(" "), _c('span', {
    staticClass: "wd-user-content-span1"
  }, [_vm._v("ID " + _vm._s(_vm.data.recodeCode))]), _vm._v(" "), _c('div', {
    staticClass: "wd-user-count"
  }, [_c('span', {
    staticClass: "wd-user-count-item",
    on: {
      "click": function($event) {
        return _vm.handleShowGuanzhu(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.guanzhong')) + "： " + _vm._s(_vm.data.followCount || 0))]), _vm._v(" "), _c('span', {
    staticClass: "wd-user-count-item",
    on: {
      "click": function($event) {
        return _vm.handleShowGuanzhu(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.fensi')) + "： " + _vm._s(_vm.data.vermicelliCount || 0))])])]), _vm._v(" "), _c('div', {
    staticClass: "wd-user-edit",
    on: {
      "click": _vm.handleShowXgzl
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/image/xiugaiziliao@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('all.xiugaiziliao')))])])]), _vm._v(" "), _c('div', {
    staticClass: "zhibozhongxin",
    on: {
      "click": _vm.handleGoZhibozhongxin
    }
  }, [_vm._v(_vm._s(_vm.$t('all.zhibozhongxin')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "wd-zican"
  }, [_c('div', {
    staticClass: "wd-zican-title"
  }, [_c('span', {
    staticClass: "wd-zican-title-span"
  }, [_vm._v(_vm._s(_vm.$t('all.zongzichanguzhi')))])]), _vm._v(" "), _c('div', {
    staticClass: "wd-zican-box",
    on: {
      "click": _vm.handleGoWallet
    }
  }, [_c('div', {
    staticClass: "wd-zican-box-num"
  }, [_vm._v(_vm._s(_vm.userWalletInfo ? _vm.userWalletInfo.valuationAmount : 0) + " " + _vm._s(_vm.userWalletInfo.toName))]), _vm._v(" "), _c('div', {
    staticClass: "wd-zican-box-right"
  }, _vm._l((_vm.userWalletInfo.walletList), function(item, index) {
    return _c('div', {
      staticClass: "wd-zican-box-right-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.handleGoLiushui(item)
        }
      }
    }, [(item.currencyLogo) ? _c('img', {
      staticClass: "wd-zican-box-right-item-logo",
      attrs: {
        "src": item.currencyLogo,
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "wd-zican-box-right-item-text"
    }, [_c('span', {
      staticClass: "wd-zican-box-right-item-span"
    }, [_vm._v(_vm._s(item.currencyName))]), _vm._v(" "), _c('span', {
      staticClass: "wd-zican-box-right-item-span1"
    }, [_vm._v(_vm._s(_vm.$t('all.keyong')) + " " + _vm._s(item.sumAvailableAmount) + " " + _vm._s(_vm.$t('all.dongjie')) + " " + _vm._s(item.sumFreezeAmount))])])])
  }), 0)])]), _vm._v(" "), (_vm.appConfigInfo && _vm.appConfigInfo.videoStatus == 1) ? _c('duanyingyin', {
    ref: "duanyingyin"
  }) : _vm._e()], 1), _vm._v(" "), _c('xiaofeimingxi', {
    ref: "xfmx"
  }), _vm._v(" "), _c('xiugaiziliao', {
    ref: "xgzl"
  }), _vm._v(" "), _c('guanzhu', {
    ref: "gz",
    on: {
      "change": _vm.getPresentUserInfo
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24234428"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pages/wode/wode.vue
// module id = 1008
// module chunks = 1